export default "__VITE_ASSET__e5hsEeES__$_?assetResource__"